import React, { FC } from 'react';
import styled from 'styled-components';

import whiteStar from '../../../icons/white-star.svg';
import greyStar from '../../../icons/grey-star-v2.svg';

export const StarIcon = styled.div.attrs(
  ({ size = 18, margin = 3, filled, full = whiteStar, empty = greyStar }: any) => ({
    style: {
      width: `${size}px`,
      height: `${size}px`,
      marginRight: `${margin}px`,
      background: `url(${
        filled ? full : empty
      }) center center / contain no-repeat`
    }
  })
)`
  position: relative;
  display: inline-block;
`;

const PartialStarContainer = styled.div.attrs<any, any>(({ coverWidth }: any) => ({
  style: {
    width: `${coverWidth}%`
  }
}))`
  position: absolute;
  overflow: hidden;
`;

interface StarProps {
  filledStars: number;
}

interface StarGroupProps extends StarProps {
  Star?: any;
  full?: any
  empty?: any
}

export const StarGroup: FC<StarGroupProps> = ({
  filledStars,
  Star = StarIcon,
  full,
  empty,
}) => {
  const stars = [];
  for (let i = 1; i <= 5; i += 1) {
    const remainingStars = Math.max(0, filledStars - (i - 1));
    let partialStar;
    if (remainingStars < 1 && remainingStars > 0) {
      partialStar = (
        <PartialStarContainer coverWidth={remainingStars * 100}>
          <Star margin={0} filled style={{ display: 'block' }} />
        </PartialStarContainer>
      );
    }
    stars.push(
      <Star key={i} filled={i <= filledStars} full={full} empty={empty}>
        {partialStar}
      </Star>
    );
  }

  return <div>{stars}</div>;
};

export const WhiteGreyStarGroup: FC<StarProps> = ({ filledStars }) => (
  <StarGroup filledStars={filledStars} full={whiteStar} empty={greyStar} />
);
